import { useEffect } from "react";
import { setTime } from "react-datepicker/dist/date_utils";
import { Link } from "react-router-dom";

export const MobileAppRedirect = () => {

    useEffect(() => {
        setTimeout(() => {
            window.location.href = '/';
        }, 1000)
    }, []);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor;
        if (/android/i.test(userAgent)) {
            window.location.href = 'https://play.google.com/store/apps/details?id=pl.pirslab.totupointmobile';
        } else if (/iPad|iPhone|iPod/.test(userAgent)) {
            window.location.href = 'https://apps.apple.com/pl/app/totupoint-2/id6754378766?l=pl';
        }

    }, []);

    return <div className="my-7 w-full  text-center ">
        <Link className="text-blue-400" to={"/"}>Wróć do strony głównej</Link>
    </div>
};
